import withPrefix from '@/utils/withPrefix'

export default withPrefix('/brands/:brandId/sites/:siteId', [
  {
    path: '/pages',
    name: 'pages',
    component: () => import('./views/PagesIndex'),
    meta: {
      auth: true
    }
  },
  {
    path: '/pages/new',
    name: 'pagesNew',
    component: () => import('./views/PagesNew'),
    meta: {
      auth: true
    }
  },
  {
    path: '/pages/:id/:languageId',
    name: 'pagesEditNew',
    component: () => import('./views/PagesEditNew'),
    meta: {
      auth: true
    }
  }
])
